module.exports = __webpack_public_path__ + "ath_game_web/img/7.2.6b8e586d.png";